
        <div class="min-h-[100svh] flex items-start justify-center bg-[color:var(--background)] text-[color:var(--foreground)] relative px-4 py-4 lg:items-center lg:py-12">
            <div class="lux-auth-bg absolute inset-0 pointer-events-none"></div>

            <div class="relative z-10 w-full max-w-6xl grid lg:grid-cols-2 gap-10 items-stretch lg:items-center">
                <div class="hidden lg:block">
                    <div class="lux-panel lux-hover overflow-hidden rounded-[36px]">
                        <div class="relative h-[560px]">
                            <img
                                [src]="authHeroImage"
                                alt="nibni"
                                class="h-full w-full object-cover"
                                loading="eager"
                                fetchpriority="high"
                                decoding="async"
                            />
                            <div class="absolute inset-0 bg-gradient-to-tr from-black/80 via-black/40 to-transparent"></div>

                            <div class="absolute inset-x-0 bottom-0 p-10">
                                <div class="inline-flex items-center gap-2 rounded-full border border-white/15 bg-black/40 px-4 py-2 text-xs font-semibold text-white/90 backdrop-blur">
                                    <lucide-icon name="shield-check" class="h-4 w-4 text-[#aa9072]"></lucide-icon>
                                    Secure access to premium inventory
                                </div>

                                <h1 class="mt-6 text-5xl font-semibold tracking-tight text-white leading-[1.05]">
                                    Welcome back
                                </h1>
                                <p class="mt-3 text-lg text-white/80 max-w-md">
                                    Sign in to access your nibni account.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="lux-panel min-w-0 w-full flex flex-col rounded-[32px] p-6 sm:p-8 shadow-[0_22px_50px_rgba(15,23,42,0.14)]">

                    <div class="mt-8 space-y-2">
                        <h2 class="text-3xl font-semibold tracking-tight text-[color:var(--foreground)]">Sign in</h2>
                        <p class="text-sm text-[color:var(--muted-foreground)]">Choose your preferred sign-in method.</p>
                    </div>

                    <div class="mt-6 grid gap-3">
                        <div class="flex items-center gap-2 rounded-full border border-[color:var(--border)] bg-[color:var(--secondary)] p-1">
                            <button
                                type="button"
                                class="h-10 flex-1 rounded-full text-sm font-semibold transition"
                                [ngClass]="identifier() === 'phone' ? 'bg-[color:var(--card)] shadow text-[color:var(--foreground)]' : 'text-[color:var(--muted-foreground)] hover:text-[color:var(--foreground)]'"
                                (click)="setIdentifier('phone')"
                            >
                                Phone
                            </button>
                            <button
                                type="button"
                                class="h-10 flex-1 rounded-full text-sm font-semibold transition"
                                [ngClass]="identifier() === 'email' ? 'bg-[color:var(--card)] shadow text-[color:var(--foreground)]' : 'text-[color:var(--muted-foreground)] hover:text-[color:var(--foreground)]'"
                                (click)="setIdentifier('email')"
                            >
                                Email
                            </button>
                        </div>

                        <div class="flex items-center gap-2 rounded-full border border-[color:var(--border)] bg-[color:var(--secondary)] p-1">
                            <button
                                type="button"
                                class="h-10 flex-1 rounded-full text-sm font-semibold transition"
                                [ngClass]="method() === 'otp' ? 'bg-[color:var(--card)] shadow text-[color:var(--foreground)]' : 'text-[color:var(--muted-foreground)] hover:text-[color:var(--foreground)]'"
                                (click)="setMethod('otp')"
                            >
                                One-time code
                            </button>
                            <button
                                type="button"
                                class="h-10 flex-1 rounded-full text-sm font-semibold transition"
                                [ngClass]="method() === 'password' ? 'bg-[color:var(--card)] shadow text-[color:var(--foreground)]' : 'text-[color:var(--muted-foreground)] hover:text-[color:var(--foreground)]'"
                                (click)="setMethod('password')"
                            >
                                Password
                            </button>
                        </div>
                    </div>

                    <form *ngIf="method() === 'otp'" [formGroup]="otpForm" (ngSubmit)="onOtpSubmit()" class="mt-6 space-y-4">
                        <ng-container *ngIf="identifier() === 'phone'">
                            <app-phone-input formControlName="mobile"></app-phone-input>
                        </ng-container>

                        <label *ngIf="identifier() === 'email'" class="space-y-1 block">
                            <span class="text-sm font-semibold text-[color:var(--muted-foreground)]">Email</span>
                            <input
                                formControlName="email"
                                type="email"
                                class="w-full rounded-xl border border-[color:var(--input)] bg-[color:var(--card)] px-4 py-3 text-[color:var(--foreground)] placeholder:text-[color:var(--text-subtle)] focus:border-[color:var(--ring)] focus:outline-none"
                                placeholder="name@example.com"
                            />
                        </label>

                        <div *ngIf="otpStep() === 'code'" class="space-y-2">
                            <label class="space-y-1 block">
                                <span class="text-sm font-semibold text-[color:var(--muted-foreground)]">Code</span>
                                <input
                                    formControlName="code"
                                    inputmode="numeric"
                                    autocomplete="one-time-code"
                                    class="w-full rounded-xl border border-[color:var(--input)] bg-[color:var(--card)] px-4 py-3 text-[color:var(--foreground)] placeholder:text-[color:var(--text-subtle)] focus:border-[color:var(--ring)] focus:outline-none"
                                    placeholder="123456"
                                />
                            </label>
                            <button
                                type="button"
                                (click)="resendOtp()"
                                [disabled]="loading()"
                                class="w-full rounded-xl border border-[color:var(--border)] bg-[color:var(--card)] px-4 py-3 text-sm font-semibold text-[color:var(--muted-foreground)] transition hover:bg-[color:var(--hover)] disabled:opacity-60"
                            >
                                Resend code
                            </button>
                        </div>

                        <button
                            type="submit"
                            [disabled]="loading()"
                            class="w-full rounded-xl bg-[color:var(--primary)] hover:bg-[color:var(--primary-hover)] text-[color:var(--primary-foreground)] h-12 font-semibold transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
                        >
                            <lucide-icon *ngIf="loading()" name="loader-2" class="h-4 w-4 animate-spin"></lucide-icon>
                            <span>{{ otpButtonLabel }}</span>
                        </button>

                        <div *ngIf="message()" class="rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800">
                            {{ message() }}
                        </div>
                        <div *ngIf="error()" class="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                            {{ error() }}
                        </div>
                    </form>

                    <form
                        *ngIf="method() === 'password'"
                        [formGroup]="passwordForm"
                        (ngSubmit)="onPasswordSubmit()"
                        class="mt-6 space-y-4"
                    >
                        <ng-container *ngIf="identifier() === 'phone'">
                            <app-phone-input formControlName="mobile"></app-phone-input>
                        </ng-container>

                        <label *ngIf="identifier() === 'email'" class="space-y-1 block">
                            <span class="text-sm font-semibold text-[color:var(--muted-foreground)]">Email</span>
                            <input
                                formControlName="email"
                                type="email"
                                class="w-full rounded-xl border border-[color:var(--input)] bg-[color:var(--card)] px-4 py-3 text-[color:var(--foreground)] placeholder:text-[color:var(--text-subtle)] focus:border-[color:var(--ring)] focus:outline-none"
                                placeholder="name@example.com"
                            />
                        </label>

                        <label class="space-y-1 block">
                            <span class="text-sm font-semibold text-[color:var(--muted-foreground)]">Password</span>
                            <div class="relative">
                                <input
                                    formControlName="password"
                                    [type]="showPassword() ? 'text' : 'password'"
                                    class="w-full rounded-xl border border-[color:var(--input)] bg-[color:var(--card)] px-4 py-3 pr-12 text-[color:var(--foreground)] placeholder:text-[color:var(--text-subtle)] focus:border-[color:var(--ring)] focus:outline-none"
                                    placeholder="••••••••"
                                />
                                <button
                                    type="button"
                                    (click)="showPassword.set(!showPassword())"
                                    class="absolute inset-y-0 right-2 flex items-center justify-center rounded-lg px-2 text-[color:var(--muted-foreground)] hover:text-[color:var(--foreground)] focus:outline-none focus:ring-2 focus:ring-[color:var(--ring)]/30"
                                    [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
                                    [attr.aria-pressed]="showPassword()"
                                >
                                    <lucide-icon [name]="showPassword() ? 'eye-off' : 'eye'" class="h-4 w-4"></lucide-icon>
                                </button>
                            </div>
                        </label>

                        <div class="flex justify-between items-center gap-3 text-sm">
                            <a routerLink="/forgot-password" class="font-semibold text-[color:var(--accent)] hover:underline"
                                >Forgot password?</a
                            >
                            <a routerLink="/signup" class="font-semibold text-[color:var(--muted-foreground)] hover:underline">Create account</a>
                        </div>

                        <button
                            type="submit"
                            [disabled]="loading()"
                            class="w-full rounded-xl bg-[color:var(--primary)] hover:bg-[color:var(--primary-hover)] text-[color:var(--primary-foreground)] h-12 font-semibold transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
                        >
                            <lucide-icon *ngIf="loading()" name="loader-2" class="h-4 w-4 animate-spin"></lucide-icon>
                            <span>{{ loading() ? 'Signing in...' : 'Sign in' }}</span>
                        </button>

                        <div *ngIf="message()" class="rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800">
                            {{ message() }}
                        </div>
                        <div *ngIf="error()" class="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                            {{ error() }}
                        </div>
                    </form>

		                    <div class="mt-auto flex items-center justify-center gap-2 pt-8 text-sm text-[color:var(--muted-foreground)]">
		                        <span>New to nibni?</span>
		                        <a routerLink="/signup" class="font-semibold text-[color:var(--accent)] hover:underline">Sign up</a>
		                    </div>
		                </div>

                    <div class="mt-8 lg:hidden">
                        <div class="lux-panel lux-hover overflow-hidden rounded-[28px]">
                            <div class="relative h-56 sm:h-64">
                                <img
                                    [src]="authHeroImage"
                                    alt="nibni"
                                    class="h-full w-full object-cover"
                                    loading="lazy"
                                    decoding="async"
                                />
                                <div class="absolute inset-0 bg-gradient-to-tr from-black/70 via-black/25 to-transparent"></div>
                            </div>
                        </div>
                    </div>
	            </div>
	        </div>
	    
